/**
 * Normaliza o que o usuário digita num campo que o backend usa como NOME de variável:
 * `{{x}}` viraria uma variável chamada literalmente "{{x}}", que nenhum `{{x}}` do flow
 * seguinte encontra. Vazio vira `undefined`, para o campo sair do nó em vez de gravar "".
 *
 * Mora em `shared/` porque é usada pelos dois editores de fluxo (admin-geral e
 * secretaria-arbitral), que não podem importar internos um do outro.
 *
 * @example nomeDeVariavel(' {{prazo_purga_id}} ') // 'prazo_purga_id'
 */
export const nomeDeVariavel = (valor: string): string | undefined =>
  valor.replace(/[{}\s]/g, '') || undefined;
